﻿import {translation} from "@2d-front-monorepo/core";
import {Message} from "@2d-front-monorepo/design-library";
import {DriverComponent, DriverId, Drivers} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX} from "react";
import {useParams} from "react-router";
import {API_ENDPOINT} from "../../api-endpoint";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import {usePermits} from "../../hooks/usePermits";

const filesPrefix = API_ENDPOINT.fileDownload;

export default function ViewDriver(): JSX.Element {
	const {driverId} = useParams<{ driverId: string }>() as { driverId: DriverId };
	const permitsState = usePermits();
	const driver = Drivers.get(permitsState, driverId);

	if (driverId == null || driver?.id == null) {
		return (<Message title={{text: `Invalid driver id: [${driverId}]`}} type="error"/>);
	}

	return (
		<>
			<div className="layout horizontal aligned middle">
				<h2 className="flex">{translation(PermitTranslations.driver)}</h2>
				{/*<EntityStatusComponent entity={driver}/>*/}
			</div>
			<hr className="no-margin-start"/>
			<DriverComponent driver={driver} filesPrefix={filesPrefix}/>
			<PermitsBackButtonFrame/>
		</>
	)
}
